import { useRef, useState } from 'react';
import { Dropdown, DropdownTrigger, DropdownContent, DropdownCheckboxItem } from './dropdown';

function ColumnToggleDropdown({ colunas, visibilidade, onToggle, label = 'Colunas', align = 'end' }) {
  const [open, setOpen] = useState(false);
  const triggerRef = useRef(null);

  return (
    <Dropdown>
      <DropdownTrigger
        ref={triggerRef}
        onClick={() => setOpen((antigo) => !antigo)}
        aria-expanded={open}
        data-state={open ? 'open' : 'closed'}
      >
        {label}
      </DropdownTrigger>
      <DropdownContent
        open={open}
        onClose={() => setOpen(false)}
        align={align}
        anchorRef={triggerRef}
      >
        <div className="tw-flex tw-flex-col tw-gap-1.5">
          {colunas.map((coluna) => (
            <DropdownCheckboxItem
              key={`toggle-${coluna.id}`}
              label={coluna.label}
              checked={visibilidade[coluna.id] !== false}
              disabled={coluna.canHide === false}
              onCheckedChange={() => onToggle(coluna.id)}
            />
          ))}
        </div>
      </DropdownContent>
    </Dropdown>
  );
}

export default ColumnToggleDropdown;
